import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { LanguageIcon } from '@seedlang/icons';
import FlagButton from 'components/button/flag_button';
import { SourceItemWrapper } from '@seedlang/hoc';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  background: whitesmoke;
  margin: 10px 0;
`;

const Source = styled.div`
  flex: 1;
`;

const Row = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const LeftRowContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

@observer
class SourceItem extends React.Component {

  render() {
    return (
      <Wrapper>
        <Row>
          <LeftRowContent>
            <LanguageIcon
              languageId={this.props.translationSource?.source?.languageId}
              margin='0 10px 0 0'
            />
            <Source>
              {this.props.sourceText}
            </Source>
          </LeftRowContent>
          <FlagButton
            translationSource={this.props.translationSource}
            word={this.props.word || this.props.sentence}
            onAfterFlag={this.props.afterSubmission}
            margin='0 0 0 auto'
          />
        </Row>
        {
          this.props.showMessage &&
            <Row
              style={{
                background: '#4CAF50',
                color: '#FFF',
                padding: '10px',
                borderRadius: '5px',
                width: '100%',
                marginTop: '10px'
              }}
            >
              {this.props.successMessage}
            </Row>
        }
    </Wrapper>
    );
  }
}

export default SourceItemWrapper(SourceItem);
